module.exports = {
  title: 'bycard',
  fixedHeader: false,
  sidebarLogo: true
};